import { defineComponent } from 'vue';
export default defineComponent({
  name: 'MaterialItem',
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup: function setup() {
    return {};
  }
});